import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flex _gap-2 _shrink-0 _ai-fs _as-fs"
}
const _hoisted_2 = {
  key: 0,
  class: "gfua-screen__dropdown-wrapper"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_balloon_actions = _resolveComponent("balloon-actions")

  return ($options.hasContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "prefixActions"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.screenActions, (action) => {
          return (_openBlock(), _createBlock(_component_tooltip, {
            key: action.key,
            enabled: action.tooltipVisibility,
            text: action.tooltipText
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon_base_button, _mergeProps({ ref_for: true }, action.props, {
                onClick: action.fn
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(action.text), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["enabled", "text"]))
        }), 128 /* KEYED_FRAGMENT */)),
        ($options.hasBalloon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_balloon_actions, {
                actions: $options.screenBalloonActions,
                theme: $props.balloonTheme,
                mode: _ctx.balloonActionMode,
                "data-qa": "screen-actions:balloon"
              }, null, 8 /* PROPS */, ["actions", "theme", "mode"])
            ]))
          : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "suffixActions")
      ]))
    : _createCommentVNode("v-if", true)
}